import { BCMSDate, BCMSRecord, BCMSRecordProperty } from "@bcm-dev/bcms-vite";
import { Profile } from "model";

/**
* @class TaxDocument
* @classdesc Class definition for record type from model
* @param {OBJECT} record - record from model to init class
* @extends BCMSRecord
* @example const record = model.taxDocuments[0];
* const taxDocument = new TaxDocument(record);
* @property {NUMBER} _id - The id of the taxDocument.
* @property {STRING} _description - The description of the taxDocument.
*/
export default class TaxDocument extends BCMSRecord {
    _id
    _profile
    _description

    constructor(record) {     
        super(record);
    }
    get date(){
        return BCMSDate.init([15,1,"c"]).isBefore(BCMSDate.init())? BCMSDate.init([15,1,"c"]):BCMSDate.init([15,1,-1])
   } 
}

TaxDocument.define({
    "recordType": "taxDocuments",
    "recordIDProp": "id",
    "className": "TaxDocument",
    "recordProperties": [
        /** 
         * @name id
         * @instance
         * @property get {NUMBER} - gets the id.
         * @property set {NUMBER} - sets the id.
         * @memberof TaxDocument
         */
        BCMSRecordProperty.mapToNumber("id","_id"),

        /** 
         * @name profile
         * @instance
         * @property get {NUMBER} - gets the profile.
         * @property set {NUMBER} - sets the profile.
         * @memberof TaxDocument
         */
        BCMSRecordProperty.mapToClass("profile", "_profile", () => Profile),

        /** 
         * @name description
         * @instance
         * @property get {STRING} - gets the description.
         * @property set {STRING} - sets the description.
         * @memberof TaxDocument
         */
        BCMSRecordProperty.mapToString("description", "_description"),

        /** 
         * @name date
         * @instance
         * @property get {STRING} - gets the date.
         * @property set {STRING} - sets the date.
         * @memberof TaxDocument
         */
       // BCMSRecordProperty.mapToDate("date", "_date")
    ]  
})




